/** WebSocket close codes of room connections (RFC 6455 §7.4.1; 4000–4999 are ours). */
export const CloseCode = {
  normal: 1000,
  goingAway: 1001,
  policyViolation: 1008,
  internalError: 1011,
  tryAgainLater: 1013,
  /** The same seat connected again; the older connection is dropped. */
  replaced: 4000,
  /** The seat claim is missing, forged, expired or for another room. */
  claimRejected: 4001,
  /** The match is over (or the room never started). */
  roomClosed: 4002,
  /** The claim is valid but its player is not on this room's roster. */
  notSeated: 4003,
  /** The room server behind the edge proxy could not be reached. */
  upstreamFailed: 4004,
} as const
export type CloseCode = (typeof CloseCode)[keyof typeof CloseCode]
